import { z } from 'zod';

// CSP của Nginx không cho 'unsafe-eval': tắt bước dò `new Function` (JIT) của Zod 4 để tránh lỗi CSP trên console.
// Phải chạy TRƯỚC khi bất kỳ schema nào được tạo (Zod dò khả năng eval lúc khởi tạo z.object) — vì vậy
// main.tsx import tệp này đầu tiên. Kết quả validate không đổi (Zod vốn tự chuyển sang chế độ không JIT khi bị chặn).
z.config({ jitless: true });
